<template>
  <v-container ref="pageBanks" fluid tag="section">
    <material-card icon="mdi-bank" icon-small title="Товари в кредит" color="accent" class="mb-16">
      <!--Фильтры-->
      <v-row class="mx-2 mb-2">
        <v-col cols="12" md="3">
          <v-select return-object item-text="name" item-value="name" v-model="project" :items="projects" label="Проект"
            clearable @change="setQueryParam()"></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select return-object item-text="name" item-value="name" v-model="bank" :items="banks" label="Банк"
            clearable @change="getBankProductsData()"></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select return-object item-text="name" item-value="name" v-model="bankProduct" :items="bankProducts"
            label="Банківський продукт" clearable @change="setQueryParam()"></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field v-model="good" label="Товар" clearable @change="setQueryParam()"></v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="text-right">
          <v-btn v-if="isManager || isAdmin" color="primary" min-width="150" @click="deleteSelectedCredits"
            :disabled="!selectedCredits.length">
            Видалити вибрані ({{ selectedCredits.length }})
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mx-2 mb-2">
        <v-col cols="12" md="3">
          <v-btn v-if="isManager || isAdmin" class="pa-1 "
            @click="exportXlsx()"><v-icon>mdi-export</v-icon>&nbsp;Експорт XLSX</v-btn>
          <v-btn v-if="isManager || isAdmin" class="pa-1 mx-2"
            @click="importXlsx()"><v-icon>mdi-import</v-icon>&nbsp;Імпорт XLSX</v-btn>
        </v-col>
      </v-row>

    </material-card>
    <v-simple-table>
      <thead>
        <tr>
          <th class="primary--text" width="20">
            <v-checkbox :input-value="false" v-model="selectedAll" title="Вибрати всі"></v-checkbox>
          </th>
          <th class="primary--text" width="20">
            ID
          </th>
          <th class="primary--text" width="30%">
            Назва
          </th>
          <th class="primary--text">
            Код Тайфуну
          </th>
          <th class="primary--text">
            Банк
          </th>
          <th class="primary--text">
            Банківський продукт
          </th>
          <th class="primary--text">
            Проєкт
          </th>
          <th class="primary--text" width="10">
            Включено
          </th>
          <th width="50"></th>
        </tr>
      </thead>

      <tbody v-if="bankCredits.length">
        <tr v-for="(credit, index) in bankCredits" :key="credit.id">
          <td><v-checkbox v-model="selectedCredits" :value="credit.id"></v-checkbox></td>
          <td>{{ credit.id }}</td>
          <td>{{ credit.name }}</td>
          <td>{{ credit.typhoon_id }}</td>
          <td>{{ credit.bank_name }}</td>
          <td>{{ credit.bank_product_name }}</td>
          <td>{{ credit.project_name }}</td>
          <td><v-icon v-if="credit.enabled">mdi-check</v-icon></td>
          <td>
            <span class="d-flex">
              <v-icon v-if="isManager || isAdmin" class="mr-4" color="green"
                @click="$router.push(`/bank-credit-for-goods/${credit.id}/`)">
                mdi-pencil
              </v-icon>
              <v-icon v-if="isAdmin" color="error" @click="deleteProduct(credit.id)">
                mdi-delete
              </v-icon>
            </span>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!--Пагинация-->
    <div v-if="pagesCount >= 1" class="text-center py-4">
      <v-pagination @input="setQueryParam(pageCurrent)" v-model="pageCurrent" :total-visible="9"
        :length="pagesCount"></v-pagination>
    </div>
    <DialogConfitmDelete ref="dialogConfirmDelete" />
    <Preloader v-if="isSending" />
    <v-btn v-if="isManager || isAdmin" class="add-user__button" fab dark color="primary" @click="addDialog = true">
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>

    <v-dialog max-width="600" v-model="addDialog">
      <v-card>
        <v-card-title class="text-h5 justify-space-between">
          Додати товар
          <v-icon large @click="addDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-form class="pa-5 form" lazy-validation v-model="isValidForm" ref="form">
          <!--Код тайфун-->
          <div class="d-flex align-center">
            <v-text-field label="Введіть код Тайфун" v-model.trim="product.typhoon_id" :error-messages="errorProduct" />
            <v-btn class="ml-2" color="primary" small @click="checkActionProduct()">
              Перевірити
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadDialog" max-width="600">
        <v-card class="pa-2 pa-md-4">
            <v-card-title class="text-h5 justify-space-between">
                Завантажити товари в кредит
            </v-card-title>
            <v-card-text class="px-4">
                <v-file-input v-model="uploadFile" :rules="[v => !!v ]"
                    accept=".xlsx" label="Виберіть файл .xlsx" outlined dense></v-file-input>
                    <p class="pb-8 px-10"> 
                    <b>Формат файлу (порядок колонок):</b> <br>
                      1.	Код Тайфун товару<br>
                      2.	ID банку<br>
                      3.	ID продукту банку<br>
                      4.	ID проекту<br>
                      5.	Включено = 0/1<br>
                    </p>
                <v-btn :disabled="!uploadFile" @click="upload()" color="primary"
                    :loading="uploadLoading">
                    Завантажити
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="report" max-width="600">
        <v-card class="pa-2 pa-md-4">
            <v-card-title class="text-h5 justify-space-between">
                Результат завантаження товарів
            </v-card-title>
            <v-card-text class="px-4 mb-6">
              Рядків у файлі: {{ reportData.totalRows }}<br>
              Оновлено товарів в кредит: {{ reportData.updated }}<br>
              Додано товарів в кредит: {{ reportData.added }}<br>
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { IMAGE_BASE_URL } from '@/env.config';

export default {
  name: 'RegularTablesView',
  data() {
    return {
      bankCredits: [],
      // Список банків
      banks: [],
      bank: null,
      bankProducts: [],
      bankProduct: null,
      // Тецущий проект
      project: {},
      good: null,
      // Текущая страница
      pageCurrent: null,
      // Количество акций на странице
      pageLimitItems: 50,
      // Количество страниц
      pagesCount: 1,
      // Выполняется отправка на сервер
      isSending: false,
      imageBaseUrl: `${IMAGE_BASE_URL}banks/`,
      isValidForm: false,
      addDialog: false,
      errorProduct: '',
      errorRequired: 'Це поле обов’язкове',
      product: {
        typhoon_id: '',
        name: '',
        link: '',
      },
      selectedAll: false,
      selectedCredits: [],
      xlsLoading: false,
      fileName: "",
      fileBlobURL: "",
      mime: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        xml: "application/xml",
      },
      uploadDialog: false,
      uploadFile: null,
      uploadLoading: false,
      report: false,
      reportData: {
        totalRows: 0,
        updated: 0,
        added: 0,
      },
    }
  },
  computed: {
    ...mapGetters(['isManager', 'isAdmin', 'projects']),
  },

  mounted() {
    this.init();
  },

  watch: {
    // Сделано через watch  чтобы отслеживать переходы вне страницы (например если пользователь нажмёт в меню /banks/)
    '$route': {
      handler() {
        this.getBankCredits();
      },
      deep: true,
    },
    selectedAll(val) {
      if (val) {
        this.selectedCredits = this.bankCredits.map(credit => credit.id);
      } else {
        this.selectedCredits = [];
      }
    },
  },

  methods: {
    ...mapMutations(['setSnackbar']),
    ...mapActions(['getProjects','exportCreditsProducts']),

    async init() {
      await this.getProjects();
      await this.getBanks();
      await this.getBankCredits();
    },

    // Получить список 
    async getBankCredits() {
      let { project = null, page = 1, good = null, bank = null, bankProduct = null } = this.$route.query;
      this.project = this.projects.find((el) => el.id == project);
      this.pageCurrent = +page;

      try {
        let { data } = await HTTP.post('/get-list-bank-credit-for-goods', {
          limit: this.pageLimitItems,
          page,
          bank,
          bankProduct,
          good,
          project
        });

        this.bankCredits = data?.content?.data || [];
        this.pagesCount = data?.content?.pagination?.pages || 1;
      } catch (error) {
        console.warn(error);
      }
    },
    async getBanks() {
      let { project = null, page = 1 } = this.$route.query;
      this.project = this.projects.find((el) => el.id == project);
      this.pageCurrent = +page;

      try {
        let { data } = await HTTP.post('/get-list-banks', {
          limit: this.pageLimitItems,
          page,
        });

        this.banks = data?.content?.data || [];
        this.pagesCount = data?.content?.pagination?.pages || 1;
      } catch (error) {
        console.warn(error);
      }
    },
    async getBankProducts() {
      try {
        let { data } = await HTTP.post('/get-list-bank-product', {
          bank: this.bank?.id,
        });

        this.bankProducts = data?.content?.data || [];
      } catch (error) {
        console.warn(error);
      }
    },
    getBankProductsData() {
      if (this.bank) {
        this.getBankProducts();
      } else {
        this.bankProducts = [];
      }
      this.setQueryParam();
    },
    // Добавляем query параметры в урл
    setQueryParam(page = 1) {
      this.pageCurrent = page;
      let query = {
        project: this.project?.id,
        good: this.good,
        page: this.pageCurrent,
        bank: this.bank?.id,
        bankProduct: this.bankProduct?.id,
      };

      for (let key in query) {
        if (!query[key] || (key === 'page' && query?.page <= 1)) {
          delete query[key];
        }
      };

      let query1 = JSON.stringify(query).split('"').join('');
      let query2 = JSON.stringify(this.$route.query).split('"').join('');

      if (query1 != query2) {
        this.$router.push({ query });
      }
      return query;
    },

    // Удалить товар
    async deleteProduct(productId = null) {
      let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
      if (!isConfirmDelete) return;
      this.isSending = true;

      try {
        await HTTP.post('/delete-bank-credit-for-goods', { id: productId });
        this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
        this.getBankCredits();
      } catch (error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },
    // Получить товар по Тайфун id
    async checkActionProduct() {
      this.errorProduct = '';
      this.isSendingForm = true;
      try {
        let { data } = await HTTP.post('/check-action-product', {
          typhoon_id: this.product.typhoon_id,
          lang_key: 'ua'
        });
        Object.assign(this.product, data.content)
      } catch (error) {
        for (let key in this.product) {
          this.product[key] = '';
        }
        console.warn(error);
        this.errorProduct = 'Товар не знайдено';
      } finally {
        this.isSendingForm = false;
        this.$router.push(`/bank-credit-for-goods/add/?typhoon_id=${this.product.typhoon_id}&name=${this.product.name}`);
      }
    },
    async deleteSelectedCredits() {
      let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
      if (!isConfirmDelete) return;
      this.isSending = true;

      try {
        await HTTP.post('/delete-multiple-bank-credit-for-goods', { ids: this.selectedCredits });
        this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
        this.getBankCredits();
        this.selectedCredits = [];
        this.selectedAll = false;
      } catch (error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },
    exportXlsx() {
      window.URL.revokeObjectURL(this.fileBlobURL); //очистить память от ранее принятого файла
      this.xlsLoading = true;
      this.exportCreditsProducts({})
      .then((data) => {
        this.saveData(data, "credited-products.xlsx");
        this.xlsLoading = false;
      });
    },
    saveData(data, fileName) {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      var buf = Buffer.from(data, "base64");
      const blob = new Blob([buf], {
        type: this.mime["xlsx"],
      });
      let url = window.URL.createObjectURL(blob);
      this.fileBlobURL = a.href = url;
      a.download = fileName;
      a.click();
    },
    importXlsx() {
      this.uploadDialog = true;
      this.uploadFile = null;
      this.reportData = {
        totalRows: 0,
        updated: 0,
        added: 0,
      };
    },
    async upload() {
      this.uploadLoading = true;
      const formData = new FormData();
      formData.append("file", this.uploadFile);
      try {
        let { data } = await HTTP.post('/import-bank-credits-for-goods', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.reportData = data?.content || {};
        this.report = true;
        this.uploadDialog = false;
        this.getBankCredits();
      } catch (error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.uploadLoading = false;
      }
    }
  },
}

</script>

<style>
.add-user__button {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
</style>
